/* eslint-disable jsx-a11y/anchor-is-valid */
import { MoreDropDown } from "../../../common";
import { useBillsExtra } from "./useBillsExtra.js";
import primaryComponents from "../../../primaryComponents/index.js";

export const BillsExtra = ({
  billsDetails = {},
  btnStyles = {},
  showDownloadBtnFlat = false,
}) => {
  const { handleDownloadBills } = useBillsExtra({});

  return (
    <>
      {showDownloadBtnFlat ? (
        <primaryComponents.Button
          classNames={"btn btn--outline"}
          onClick={() => handleDownloadBills(billsDetails)}
        >
          Download Bill
        </primaryComponents.Button>
      ) : (
        <MoreDropDown btnStyles={btnStyles}>
          <a
            className="cursor-pointer"
            onClick={() => handleDownloadBills(billsDetails)}
          >
            Download Bill
          </a>
        </MoreDropDown>
      )}
    </>
  );
};
